<script>
	/**
	 * @typedef {Object} Props
	 * @property {number} [size]
	 * @property {string} [color]
	 */
	/** @type {Props} */
	let { size = 24, color = '#FFFFFF' } = $props()
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 50 50"
	width={size}
	height={size}
	class="spinner"
>
	<circle
		class="path"
		cx="25"
		cy="25"
		r="20"
		fill="none"
		stroke={color}
		stroke-width="4"
		stroke-linecap="round"
	/>
</svg>

<style>
	.spinner {
		animation: rotate 2s linear infinite;
	}

	.path {
		stroke-dasharray: 1, 150;
		stroke-dashoffset: 0;
		animation:
			dash 1.5s ease-in-out infinite,
			color 6s ease-in-out infinite;
	}

	@keyframes rotate {
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes dash {
		0% {
			stroke-dasharray: 1, 150;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -124;
		}
	}
</style>
